export default class OrdersCollection {
  constructor(type, orders = []) {
    this.type = type;
    this.orders = orders;
    this.campaignId = undefined;
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.total = 0;
    this.startDate = null;
    this.endDate = null;
    this.query = null;
    this.exportUrl = null;
    this.exportOfflineUrl = null;
    this.sortColumn = this.type !== 'breakdown' ? 'created_at' : 'product_name';
    this.sortDirection = this.type === 'breakdown'? 1 : 0;
    this.relaunchCampaignId = null;
  }
}